import DapDSLink from './link.component'

export * from './link.component'
export default DapDSLink

DapDSLink.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-link': DapDSLink
  }
}
